// Strips markdown artifacts (**bold**, __bold__, #heading) from AI-generated
// text at render time. The backend already strips these at generation time
// (Teechaa-backend/utils/aiClient.js), but that only covers content
// generated *after* that fix shipped — anything saved earlier still has the
// raw markdown in the DB. Applying the same cleanup here fixes both old and
// new records without a data migration.
export const formatAiText = (text) => {
    if (typeof text !== "string") return text;
    return text
        .replace(/\*\*(.*?)\*\*/gs, "$1")
        .replace(/__(.*?)__/gs, "$1")
        .replace(/^#{1,6}\s+/gm, "")
        .trim();
};
